import React, { useState, useEffect, useCallback } from "react";
import { invitationTemplateEventName } from "../../../util/invitationTemplateCatalog";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { setEventServiceData, clearEventServiceData } from "../../../store/eventServiceSlice";
import { fetchEvent } from "../../../Apiservices/Auth/servers/fetchEvents";
import { updateEvent } from "../../../Apiservices/Auth/servers/createEvents";
import { 
    fetchinvitationtemplates, 
    getinvitation_templates_by_category 
} from "../../../Apiservices/Auth/servers/fetchinvitationtemplates";
import config from "../../../config";
import providerData from "../../../ProviderServices.json";
import SendInvitationDialog from "../../../component/eventComponent/EventTabs/SendInvitationDialog";
import ChooseTemplateDialog from "../../../component/eventComponent/EventTabs/ChooseTemplateDialog";
import HostNameDialog from "../../../component/eventComponent/EventTabs/HostNameDialog";

const HeroSection = ({ service, providerListStorageKey, data }) => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const screensize = window.innerWidth;
    
    const [showEventDialog, setShowEventDialog] = useState(false);
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [pendingButtonText, setPendingButtonText] = useState(null);
    const [showInviteOptions, setShowInviteOptions] = useState(false);
    const [inviteEventData, setInviteEventData] = useState(null);
    
    // Invitation flow states
    const [chooseTemplateLoading, setChooseTemplateLoading] = useState(false);
    const [chooselabelforinvitation, setChooselabelforinvitation] = useState(false);
    const [inviteDialogVisible, setInviteDialogVisible] = useState(false);
    const [invitedByInputDialogVisible, setInvitedByInputDialogVisible] = useState(false);
    const [hostName, setHostName] = useState("");
    const [imageloading, setImageloading] = useState(false);
    const [imageFromEventPath, setImageFromEventPath] = useState(null);
    const [eventimages, setEventimages] = useState([]);
    const [imagetemplateslength, setImagetemplateslength] = useState(0);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [selectedTemplateError, setSelectedTemplateError] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [EventDataForInvitation, setEventDataForInvitation] = useState({});
    const [currentEvent, setCurrentEvent] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);

    const {
        HERO_TITLE_LINE_1,
        HERO_TITLE_LINE_2,
        HERO_TITLE_LINE_3,
        HERO_SUBTITLE,
        HERO_DESCRIPTION,
        SIGN_UP_BUTTON_TEXT,
        CATERING_BUTTON_TEXT,
        CONFIRM_DIALOG_HEADER,
        CONFIRM_DIALOG_MESSAGE,
    } = data;

    // Fetch upcoming events
    const fetchUpcomingEvents = useCallback(async () => {
        setLoading(true);
        try {
            const { upcomingEvents } = await fetchEvent();
            setUpcomingEvents(upcomingEvents);
        } catch (error) {
            console.error("Failed to fetch events:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const openAlertDialog = useCallback((serviceEventDetails) => {
        confirmDialog({
            message: CONFIRM_DIALOG_MESSAGE,
            header: CONFIRM_DIALOG_HEADER,
            defaultFocus: "accept",
            className: "th-auth__dialog",
            accept: () => {
                localStorage.setItem(
                    providerListStorageKey,
                    JSON.stringify(serviceEventDetails)
                );
                navigate("/login");
            },
        });
    }, [CONFIRM_DIALOG_MESSAGE, CONFIRM_DIALOG_HEADER, providerListStorageKey, navigate]);

    // Load all category images
    const load_all_category_images = useCallback(async (imagesMeta) => {
        const imageResults = [];
        try {
            for (const img of imagesMeta) {
                const fullUrl = `/templates-bg/${img.url}`;
                const blob = await getinvitation_templates_by_category(fullUrl);
                if (blob) {
                    const blobUrl = URL.createObjectURL(blob);
                    imageResults.push({ name: img.name, url: blobUrl });
                }
            }
        } catch (error) {
            console.warn("Error loading category images:", error);
        }
        return imageResults;
    }, []);

    // Main function to fetch invitation templates and images
    const callsomefunction = useCallback(async (selectedImagePath, event, hostNameValue) => {
        if (!event) return;
        
        setImageloading(true);
        setCurrentEvent(event);

        const data = {
            eventName: event.eventTitle || "",
            eventCategoryName: event.EventMasterDetails?.eventCategoryName || "",
            eventType: event.eventTitle || "",
            eventTitle: event.eventTitle || "",
            invitedBy: hostNameValue || event?.invitedBy || "",
            description: event.description || "",
            startDate: event.startDate || event.Date || "",
            startTime: event.startTime || "",
            endDate: event.endDate || "",
            endTime: event.endTime || "",
            city: event.city || "",
            area: event.area || "",
            state: event.state || "",
            venue: event.venue || event.Location || "",
            locationLat: event.locationLat || "",
            locationLong: event.locationLong || "",
            caste: event.caste || null,
            religion: event.religion || null,
            language: event.language || null,
            region: event.region || null,
        };

        setEventDataForInvitation(data);

        try {
            const category_name = data.eventCategoryName;
            const screenType = screensize > 800 ? "web" : "mobile";

            let fetch_api_image = null;
            try {
                const cleanEventTitle = invitationTemplateEventName(event);
                fetch_api_image = await fetchinvitationtemplates(
                    category_name,
                    cleanEventTitle,
                    screenType
                );
            } catch (err) {
                console.warn("Error fetching templates:", err);
                fetch_api_image = null;
            }

            const imagetrial = await load_all_category_images(fetch_api_image?.images || []);
            
            setEventimages(imagetrial);
            setImagetemplateslength(imagetrial.length);
            setCurrentIndex(0);
            
            if (selectedImagePath) {
                const matchedImage = imagetrial.find(img => img.name === selectedImagePath);
                setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
            } else {
                const matchedImage = imagetrial.find(img => img.name === event.imagePath);
                setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
            }
        } catch (error) {
            console.warn("Unexpected error in image fetching:", error);
        } finally {
            setImageloading(false);
        }
    }, [screensize, load_all_category_images]);

    // Handle host name submission
    const handleHostNameSubmit = useCallback(async (hostNameValue, eventId) => {
        try {
            const eventData = { invitedBy: hostNameValue };
            const success = await updateEvent(eventData, eventId);
            
            if (success) {
                setInvitedByInputDialogVisible(false);
                if (currentEvent) {
                    // Update the current event's invitedBy
                    setCurrentEvent(prev => ({ ...prev, invitedBy: hostNameValue }));
                    setChooselabelforinvitation(true);
                    // Fetch templates after host name is set
                    await callsomefunction(null, { ...currentEvent, invitedBy: hostNameValue }, hostNameValue);
                }
            } else {
                console.error("Failed to update event.");
            }
        } catch (error) {
            console.error("An error occurred while saving the host name", error);
            setInvitedByInputDialogVisible(false);
        }
    }, [currentEvent, callsomefunction]);

    // Handle template selection and submission
    const handletemplatesubmit = useCallback(async (templateName) => {
        if (!currentEvent) return;
        
        setSelectedTemplateError("");
        
        if (!templateName) {
            setSelectedTemplateError("Please select a template");
            return;
        }
        
        try {
            const eventData = { imagePath: templateName };
            const success = await updateEvent(eventData, currentEvent.id);
            setSelectedTemplate(templateName);

            if (success) {
                setChooselabelforinvitation(false);
                setInviteDialogVisible(true);
                await callsomefunction(templateName, currentEvent, currentEvent.invitedBy);
            } else {
                console.error("Failed to update event.");
            }
        } catch (error) {
            console.error("An error occurred while saving the template", error);
            setChooselabelforinvitation(false);
        }
    }, [currentEvent, callsomefunction]);

    // Navigate to Send Invitation (Create/Share Invitation)
    const navigateToSendInvitation = useCallback((selectedEventData) => {
        const serviceDetails = {
            id: 2,
            serviceName: "Send Invitation",
            serviceCardName: "Send Invitation",
            type: "Invitation"
        };

        const eventDetails = selectedEventData ? {
            id: selectedEventData.id,
            eventId: selectedEventData.id,
            eventTitle: selectedEventData.eventTitle || selectedEventData.eventType,
            Date: selectedEventData.startDate,
            Location: selectedEventData.venue,
            locationLat: selectedEventData.locationLat,
            locationLong: selectedEventData.locationLong,
            rsvpCounts: selectedEventData.rsvpCounts,
            EventMasterDetails: selectedEventData.EventMasterDetails,
            invitedBy: selectedEventData.invitedBy,
            shareToken: selectedEventData.shareToken,
            startTime: selectedEventData.startTime,
            endDate: selectedEventData.endDate,
            endTime: selectedEventData.endTime,
            area: selectedEventData.area,
            city: selectedEventData.city,
            state: selectedEventData.state,
            imagePath: selectedEventData.imagePath,
            description: selectedEventData.description,
            venue: selectedEventData.venue,
            eventType: selectedEventData.eventType,
        } : {};

        const serviceEventDetails = {
            serviceDetails: serviceDetails,
            eventDetails: eventDetails,
        };

        console.log("Send Invitation Service Event Details:", serviceEventDetails);

        if (isLoggedIn) {
            dispatch(clearEventServiceData());
            dispatch(setEventServiceData(serviceEventDetails));
            navigate("/event-services", { state: serviceEventDetails });
            window.scrollTo({ top: 0 });
        } else {
            openAlertDialog(serviceEventDetails);
        }
    }, [isLoggedIn, dispatch, navigate, openAlertDialog]);

    // Navigate to AI-enabled service
    const navigateToAIEnabledService = useCallback((selectedEventData) => {
        const serviceDetails = {
            id: 1,
            serviceName: "AI-enabled",
            serviceCardName: "AI-enabled",
            type: "AI-enabled"
        };

        const eventDetails = selectedEventData ? {
            id: selectedEventData.id,
            eventId: selectedEventData.id,
            eventTitle: selectedEventData.eventTitle || selectedEventData.eventType,
            Date: selectedEventData.startDate,
            Location: selectedEventData.venue,
            locationLat: selectedEventData.locationLat,
            locationLong: selectedEventData.locationLong,
            rsvpCounts: selectedEventData.rsvpCounts,
            EventMasterDetails: selectedEventData.EventMasterDetails,
            invitedBy: selectedEventData.invitedBy,
            shareToken: selectedEventData.shareToken,
            startTime: selectedEventData.startTime,
            endDate: selectedEventData.endDate,
            endTime: selectedEventData.endTime,
            area: selectedEventData.area,
            city: selectedEventData.city,
            state: selectedEventData.state,
            imagePath: selectedEventData.imagePath,
        } : {};

        const serviceEventDetails = {
            serviceDetails: serviceDetails,
            eventDetails: eventDetails,
        };

        console.log("AI-Enabled Service Event Details:", serviceEventDetails);

        if (isLoggedIn) {
            dispatch(clearEventServiceData());
            dispatch(setEventServiceData(serviceEventDetails));
            navigate("/event-services", { state: serviceEventDetails });
            window.scrollTo({ top: 0 });
        } else {
            openAlertDialog(serviceEventDetails);
        }
    }, [isLoggedIn, dispatch, navigate, openAlertDialog]);

    // Get service card name based on button text
    const getServiceCardName = useCallback((buttonText) => {
        switch (buttonText) {
            case "Book a Priest":
                return "Priest";
            case "TRY AI-ENABLED":
                return "AI-enabled";
            case "See catering in your area":
                return "Catering";
            case "Rent from Tent Houses":
                return "Rentals";
            case "Try our \"Invitations\" Feature":
                return "Invite";
            default:
                return buttonText;
        }
    }, []);

    // Navigate to regular provider services
    const navigateToProviderWithEvent = useCallback((buttonText, selectedEventData) => {
        const serviceCardName = getServiceCardName(buttonText);

        // Handle different service types
        if (serviceCardName === "AI-enabled") {
            navigateToAIEnabledService(selectedEventData);
            return;
        }

        if (serviceCardName === "Invite") {
            const isInvitedByExists = selectedEventData && selectedEventData.invitedBy;
            const haschoosentemplate = selectedEventData && selectedEventData.imagePath;

            setInviteEventData(selectedEventData);
            setCurrentEvent(selectedEventData);

            console.log("Invitation Event Data:", selectedEventData);
            console.log("isInvitedByExists:", isInvitedByExists);
            console.log("haschoosentemplate:", haschoosentemplate);

            if (isInvitedByExists) {
                if (!haschoosentemplate) {
                    setChooseTemplateLoading(true);
                    callsomefunction(null, selectedEventData, selectedEventData.invitedBy);
                    setChooseTemplateLoading(false);
                    setChooselabelforinvitation(true);
                } else if (haschoosentemplate) {
                    callsomefunction(null, selectedEventData, selectedEventData.invitedBy);
                    setInviteDialogVisible(true);
                }
            } else if (haschoosentemplate) {
                callsomefunction(null, selectedEventData, null);
                setInviteDialogVisible(true);
            } else {
                setInvitedByInputDialogVisible(true);
            }
            setShowEventDialog(false);
            return;
        }

        const serviceDetails = providerData.find(
            (item) => item.type === serviceCardName
        );

        if (!serviceDetails) {
            console.error("Service not found for:", serviceCardName);
            return;
        }

        const eventDetails = selectedEventData ? {
            eventId: selectedEventData.id,
            eventTitle: selectedEventData.eventTitle || selectedEventData.eventType,
            Date: selectedEventData.startDate,
            Location: selectedEventData.venue,
            locationLat: selectedEventData.locationLat,
            locationLong: selectedEventData.locationLong,
            rsvpCounts: selectedEventData.rsvpCounts,
            EventMasterDetails: selectedEventData.EventMasterDetails,
            invitedBy: selectedEventData.invitedBy,
            shareToken: selectedEventData.shareToken,
            startTime: selectedEventData.startTime,
            endDate: selectedEventData.endDate,
            endTime: selectedEventData.endTime,
            area: selectedEventData.area,
            city: selectedEventData.city,
            state: selectedEventData.state,
            imagePath: selectedEventData.imagePath,
        } : {};

        const serviceEventDetails = {
            serviceDetails: serviceDetails,
            eventDetails: eventDetails,
        };

        console.log("Service Event Details:", serviceEventDetails);

        if (isLoggedIn) {
            dispatch(clearEventServiceData());
            dispatch(setEventServiceData(serviceEventDetails));
            navigate("/providers", { state: serviceEventDetails });
            window.scrollTo({ top: 0 });
        } else {
            openAlertDialog(serviceEventDetails);
        }
    }, [getServiceCardName, navigateToAIEnabledService, callsomefunction, isLoggedIn, dispatch, navigate, openAlertDialog]);

    const handleButtonClick = useCallback(async (buttonText) => {
        setPendingButtonText(buttonText);
        setShowEventDialog(true);
        await fetchUpcomingEvents();
    }, [fetchUpcomingEvents]);

    const handleEventSelect = useCallback((event) => {
        setSelectedEvent(event);
    }, []);

    const handleConfirmEvent = useCallback(() => {
        if (selectedEvent) {
            navigateToProviderWithEvent(pendingButtonText, selectedEvent);
            setShowEventDialog(false);
            setSelectedEvent(null);
            setPendingButtonText(null);
        }
    }, [selectedEvent, pendingButtonText, navigateToProviderWithEvent]);

    const handleSkipEvent = useCallback(() => {
        navigateToProviderWithEvent(pendingButtonText, null);
        setShowEventDialog(false);
        setSelectedEvent(null);
        setPendingButtonText(null);
    }, [pendingButtonText, navigateToProviderWithEvent]);

    const handleCloseDialog = useCallback(() => {
        setShowEventDialog(false);
        setSelectedEvent(null);
        setPendingButtonText(null);
    }, []);

    // Handle Create New Invitation (no existing event)
    const handleCreateNewInvitation = useCallback(() => {
        setShowInviteOptions(false);
        navigateToSendInvitation(null);
    }, [navigateToSendInvitation]);

    // Handle Share Existing Invitation
    const handleShareExistingInvitation = useCallback(() => {
        setShowInviteOptions(false);
        if (inviteEventData) {
            navigateToSendInvitation(inviteEventData);
        }
    }, [inviteEventData, navigateToSendInvitation]);

    // Handle Close Invite Options
    const handleCloseInviteOptions = useCallback(() => {
        setShowInviteOptions(false);
        setInviteEventData(null);
        fetchUpcomingEvents();
    }, [fetchUpcomingEvents]);

    // Hide invite dialog
    const hideDialog = useCallback(() => {
        setInviteDialogVisible(false);
    }, []);

    // Handle template navigation
    const handlePrev = useCallback(() => {
        setCurrentIndex((prev) => (prev - 1 + eventimages.length) % eventimages.length);
    }, [eventimages.length]);

    const handleNext = useCallback(() => {
        setCurrentIndex((prev) => (prev + 1) % eventimages.length);
    }, [eventimages.length]);

    // Generate share URLs
    const shareUrl = currentEvent && currentEvent.shareToken 
        ? `${config.INVITATION_URL}/${currentEvent.shareToken}` 
        : "";
    const shareTitle = currentEvent ? `Check out this event: ${currentEvent.eventTitle}` : "";
    const whatsappMessage = encodeURIComponent(`Check out this event: ${shareUrl}`);

    // Handle copy to clipboard
    const handleCopy = useCallback(() => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(shareUrl)
                .then(() => {
                    setCopySuccess(true);
                    setTimeout(() => setCopySuccess(false), 2000);
                })
                .catch((err) => {
                    console.error("Clipboard API failed, trying fallback...", err);
                    fallbackCopyTextToClipboard(shareUrl);
                });
        } else {
            fallbackCopyTextToClipboard(shareUrl);
        }
    }, [shareUrl]);

    const fallbackCopyTextToClipboard = useCallback((text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand("copy");
            if (successful) {
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } else {
                console.error("Fallback copy failed.");
            }
        } catch (err) {
            console.error("Fallback: Unable to copy", err);
        }

        document.body.removeChild(textArea);
    }, []);

    // Handle share to social media
    const handleShare = useCallback((platform) => {
        const fullUrl = `${shareUrl}?token=${currentEvent?.shareToken || ""}`;
        let url = "";

        switch (platform) {
            case "whatsapp":
                url = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
                break;
            case "facebook":
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`;
                break;
            case "twitter":
                url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(shareTitle)}`;
                break;
            case "gmail":
                const subject = encodeURIComponent("Invitation to " + (currentEvent?.eventTitle || "Event"));
                const body = encodeURIComponent(`Hi,\n\nI would like to invite you to this event:\n\n${shareUrl}\n\nBest Regards.`);
                url = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${subject}&body=${body}`;
                break;
            default:
                console.log("Invalid platform");
                return;
        }

        window.open(url, "_blank");
    }, [shareUrl, whatsappMessage, shareTitle, currentEvent]);

    // Invitation Options Dialog Footer
    const inviteOptionsFooter = (
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', marginTop: '20px' }}>
            <Button
                variant="outlined"
                onClick={handleCloseInviteOptions}
                sx={{
                    textTransform: 'initial',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    border: '1px solid #383838',
                    color: '#383838',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: '#f5f5f5'
                    }
                }}
            >
                Cancel
            </Button>
        </div>
    );

    // Event selection dialog footer
    const dialogFooter = (
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', marginTop: '20px' }}>
            <Button
                variant="outlined"
                onClick={handleSkipEvent}
                sx={{
                    textTransform: 'initial',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    border: '1px solid #383838',
                    color: '#383838',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: '#f5f5f5'
                    }
                }}
            >
                Create New Event
            </Button>
            <Button
                variant="contained"
                onClick={handleConfirmEvent}
                disabled={!selectedEvent}
                sx={{
                    textTransform: 'initial',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    backgroundColor: '#383838',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: '#555555'
                    },
                    '&:disabled': {
                        backgroundColor: '#cccccc',
                        color: '#666666'
                    }
                }}
            >
                Continue with Selected Event
            </Button>
        </div>
    );

    return (
        <div>
            <div className="th-service__container">
                <div className="th-hero__text th-service__font__size">
                    <span className="th-hero__text__title">
                        {HERO_TITLE_LINE_1}
                        <br /> {HERO_TITLE_LINE_2}
                    </span>
                    <span className="th-hero__text__subtitle">
                        {" "}
                        {HERO_SUBTITLE}
                    </span>
                    <br />
                    <span className="th-hero__text__title">
                        {HERO_TITLE_LINE_3}
                    </span>
                </div>
                <span style={{ color: "#646464" }}>{HERO_DESCRIPTION}</span>
                <div className="th-service__buttons">
                    {!isLoggedIn && (
                        <Button
                            variant="contained"
                            className="th-nav__provider__txt"
                            sx={{
                                display: "flex",
                                textTransform: "initial",
                                height: "48px",
                                padding: "12px 24px",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                                alignSelf: "stretch",
                                borderRadius: "8px",
                                background: "#383838",
                                width: "100%",
                                '&:hover': {
                                    backgroundColor: '#555555'
                                }
                            }}
                            onClick={() => navigate("/signup")}
                        >
                            {SIGN_UP_BUTTON_TEXT}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        className="th-nav__provider__txt"
                        sx={{
                            display: "flex",
                            textTransform: "initial",
                            height: "48px",
                            padding: "12px 24px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            alignSelf: "stretch",
                            borderRadius: "8px",
                            color: "#383838",
                            border: "1px solid #383838",
                            background: "transparent",
                            width: "100%",
                            '&:hover': {
                                backgroundColor: '#f5f5f5'
                            }
                        }}
                        onClick={() => handleButtonClick(CATERING_BUTTON_TEXT)}
                    >
                        {CATERING_BUTTON_TEXT}
                    </Button>
                </div>
            </div>

            {/* Event Selection Dialog */}
            <Dialog
                visible={showEventDialog}
                onHide={handleCloseDialog}
                header="Select an Event"
                footer={dialogFooter}
                style={{ width: '90%', maxWidth: '600px' }}
                modal
                className="event-selection-dialog"
            >
                <div style={{ padding: '10px' }}>
                    <p style={{ marginBottom: '16px', color: '#646464' }}>
                        Choose an existing event to continue, or create a new one.
                    </p>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <i className="pi pi-spin pi-spinner-dotted" style={{ fontSize: '2rem', color: '#0cc0df' }}></i>
                        </div>
                    ) : upcomingEvents.length > 0 ? (
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {upcomingEvents.map((event) => (
                                <div
                                    key={event.id}
                                    onClick={() => handleEventSelect(event)}
                                    style={{
                                        padding: '12px',
                                        marginBottom: '8px',
                                        border: selectedEvent?.id === event.id ? '2px solid #0cc0df' : '1px solid #e0e0e0',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        backgroundColor: selectedEvent?.id === event.id ? '#f0f9ff' : 'white',
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <h4 style={{ margin: '0 0 4px 0', color: '#383838' }}>
                                                {event.eventTitle || event.eventType}
                                            </h4>
                                            <div style={{ fontSize: '12px', color: '#888', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                                <span>
                                                    📅 {new Date(event.startDate).toLocaleDateString()}
                                                </span>
                                                <span>
                                                    📍 {event.venue || 'Venue not specified'}
                                                </span>
                                            </div>
                                            {event.invitedBy && (
                                                <div style={{ fontSize: '11px', color: '#aaa', marginTop: '4px' }}>
                                                    Hosted by: {event.invitedBy}
                                                </div>
                                            )}
                                        </div>
                                        {selectedEvent?.id === event.id && (
                                            <i className="pi pi-check" style={{ color: '#0cc0df', fontSize: '20px' }}></i>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <p>No upcoming events found.</p>
                            <p style={{ fontSize: '14px', color: '#888' }}>Click "Create New Event" to get started.</p>
                        </div>
                    )}
                </div>
            </Dialog>

            {/* Send Invitation Dialog */}
            <SendInvitationDialog
                visible={inviteDialogVisible}
                onHide={hideDialog}
                shareUrl={shareUrl}
                shareTitle={shareTitle}
                whatsappMessage={whatsappMessage}
                image={imageFromEventPath}
                imageloading={imageloading}
                EventDataForInvitation={EventDataForInvitation}
                onCopy={handleCopy}
                onShare={handleShare}
                copySuccess={copySuccess}
            />

            {/* Choose Template Dialog */}
            <ChooseTemplateDialog
                visible={chooselabelforinvitation}
                onHide={() => setChooselabelforinvitation(false)}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                selectedTemplateError={selectedTemplateError}
                handleTemplateSubmit={handletemplatesubmit}
                imageloading={imageloading}
                eventimages={eventimages}
                currentIndex={currentIndex}
                handlePrev={handlePrev}
                handleNext={handleNext}
                imagetemplateslength={imagetemplateslength}
                EventDataForInvitation={EventDataForInvitation}
                loadingOverlay={chooseTemplateLoading}
            />

            {/* Host Name Dialog */}
            <HostNameDialog
                visible={invitedByInputDialogVisible}
                onHide={() => setInvitedByInputDialogVisible(false)}
                hostName={hostName}
                setHostName={setHostName}
                onSubmit={() => {
                    if (currentEvent) {
                        handleHostNameSubmit(hostName, currentEvent.id);
                    }
                    setInvitedByInputDialogVisible(false);
                }}
            />

            {/* Invitation Options Dialog */}
            <Dialog
                visible={showInviteOptions}
                onHide={handleCloseInviteOptions}
                header="Create or Share Invitation"
                footer={inviteOptionsFooter}
                style={{ width: '90%', maxWidth: '500px' }}
                modal
                className="invite-options-dialog"
            >
                <div style={{ padding: '20px' }}>
                    <p style={{ marginBottom: '24px', color: '#646464', textAlign: 'center' }}>
                        How would you like to proceed with your invitation?
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <Button
                            variant="contained"
                            onClick={handleCreateNewInvitation}
                            sx={{
                                textTransform: 'initial',
                                padding: '14px 20px',
                                borderRadius: '8px',
                                backgroundColor: '#0cc0df',
                                color: 'white',
                                width: '100%',
                                '&:hover': {
                                    backgroundColor: '#0aadc8'
                                }
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <i className="pi pi-plus" style={{ fontSize: '18px' }}></i>
                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                        Create New Invitation
                                    </div>
                                    <div style={{ fontSize: '12px', opacity: 0.9 }}>
                                        Start fresh with a new invitation design
                                    </div>
                                </div>
                            </div>
                        </Button>

                        {inviteEventData && inviteEventData.shareToken && (
                            <Button
                                variant="outlined"
                                onClick={handleShareExistingInvitation}
                                sx={{
                                    textTransform: 'initial',
                                    padding: '14px 20px',
                                    borderRadius: '8px',
                                    border: '2px solid #0cc0df',
                                    color: '#0cc0df',
                                    backgroundColor: 'transparent',
                                    width: '100%',
                                    '&:hover': {
                                        backgroundColor: '#f0f9ff',
                                        borderColor: '#0aadc8'
                                    }
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <i className="pi pi-share-alt" style={{ fontSize: '18px' }}></i>
                                    <div style={{ textAlign: 'left' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                            Share Existing Invitation
                                        </div>
                                        <div style={{ fontSize: '12px', opacity: 0.9 }}>
                                            Share invitation for: {inviteEventData.eventTitle || inviteEventData.eventType}
                                        </div>
                                    </div>
                                </div>
                            </Button>
                        )}

                        {inviteEventData && inviteEventData.imagePath && (
                            <Button
                                variant="outlined"
                                onClick={handleShareExistingInvitation}
                                sx={{
                                    textTransform: 'initial',
                                    padding: '14px 20px',
                                    borderRadius: '8px',
                                    border: '1px solid #383838',
                                    color: '#383838',
                                    backgroundColor: 'transparent',
                                    width: '100%',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <i className="pi pi-pencil" style={{ fontSize: '18px' }}></i>
                                    <div style={{ textAlign: 'left' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                            Edit Existing Invitation
                                        </div>
                                        <div style={{ fontSize: '12px', opacity: 0.9 }}>
                                            Modify and update your invitation
                                        </div>
                                    </div>
                                </div>
                            </Button>
                        )}
                    </div>

                    <div style={{
                        marginTop: '24px',
                        padding: '12px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '8px',
                        fontSize: '12px',
                        color: '#888',
                        textAlign: 'center'
                    }}>
                        <i className="pi pi-info-circle" style={{ marginRight: '8px' }}></i>
                        You can always access your invitations from the event dashboard
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default HeroSection;
